import api from "./axiosInstance";

const userURL = "/user";

const endpoint = {
  firstLogin: `${userURL}/firstLogin`,
  updatePhoto: `${userURL}/updatePhoto`,
  getUser: `${userURL}`,
  updateDatosPersonales: `${userURL}/updateDatosPersonales`,
  updateDatosAdicionales: `${userURL}/updateDatosAdicionales`,
  checkPersonalID: `${userURL}/checkPersonalID`,
  updateUser: (id) => `${userURL}/${id}`,
  patients: `${userURL}/patients`,
  patientReport: `${userURL}/patient-report`,
  completeProgress: `${userURL}/completeProgress`,
  professionals: `${userURL}/professionals`,
  updateOngUser: `${userURL}/updateOngUser`,
  myOngs: `${userURL}/my-ongs`,
};

// login
const firstLogin = async (userEmail) => {
  const payload = {
    userEmail: userEmail,
  };

  try {
    const { data } = await api.put(endpoint.firstLogin, payload);

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const updatePhoto = async (userID, photoKey) => {
  const payload = {
    userID: userID,
    photo: photoKey,
  };
  try {
    const { data } = await api.put(endpoint.updatePhoto, payload);
    if (data.updated === false) {
      throw new Error("Error al actualizar foto.");
    }
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const getUserData = async (userID) => {
  try {
    const { data } = await api.get(`${endpoint.getUser}/${userID}`);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const updateDatosPersonales = async (userData) => {
  const payload = {
    firstName: userData.firstName,
    lastName: userData.lastName,
    email: userData.email,
    birthDate: userData.birthDate,
    personalID: userData.personalID,
    personalIDType: userData.personalIDType,
    genre: userData.genre,
    country: userData.country,
    state: userData.state,
    district: userData.district,
    corregimiento: userData.corregimiento,
    address: userData.address,
    livingPlace: userData.livingPlace,
    livingPlaceNumber: userData.livingPlaceNumber,
    cellPhone: userData.cellPhone,
    extraContactPhone: userData.extraContactPhone,
    extraContactPhoneType: userData.extraContactPhoneType,
  };

  try {
    const { data } = await api.post(endpoint.updateDatosPersonales, payload);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const updateDatosAdicionales = async (userData) => {
  const payload = {
    email: userData.email,
    nationality: userData.nationality,
    ethnicity: userData.ethnicity,
    bloodType: userData.bloodType,
    ocupation: userData.ocupation,
    profession: userData.profession,
    citizenStatus: userData.citizenStatus,
  };

  try {
    const { data } = await api.post(endpoint.updateDatosAdicionales, payload);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const updateUser = async (id, userData) => {
  try {
    const { data } = await api.put(endpoint.updateUser(id), userData);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const getPatients = async (professional) => {
  try {
    const { data } = await api.get(
      `${endpoint.patients}?professional=${professional}`
    );
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const postPatientReport = async (report) => {
  try {
    const { data } = await api.post(endpoint.patientReport, report);
    return data;
  } catch (error) {
    const serverMsg = error.response?.data?.message;
    throw new Error(serverMsg || error.message);
  }
};

const updateCompleteProgress = async (userID) => {
  const payload = {
    userID: userID,
  };
  try {
    const { data } = await api.put(endpoint.completeProgress, payload);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const getProfessionals = async (controller, query) => {
  try {
    const { data } = await api.get(`${endpoint.professionals}?${query}`, {
      query: query,
      signal: controller.signal,
    });
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const getProfessionalSpecialities = async () => {
  try {
    const { data } = await api.get(`${endpoint.professionals}/specialities`);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const updateOngUser = async (userID, body) => {
  try {
    const payload = {
      userID: userID,
      ongID: body.ongID,
      nombreOng: body.nombreOng,
      personaDeContactoOng: body.personaDeContactoOng,
      emailOng: body.emailOng,
      telefonoOng: body.telefonoOng,
      fechaConstitucion: body.fechaConstitucion,
      paisOng: body.paisOng,
      provinciaOng: body.provinciaOng,
      correguimientoOng: body.correguimientoOng,
      distritoOng: body.distritoOng,
      direccionOng: body.direccionOng,
      localOng: body.localOng,
      Telefono2Ong: body.telefono2Ong,
      otroTelefonoOng: body.otroTelefonoOng,
      facebookOng: body.facebookOng,
      twitterOng: body.twitterOng,
      instagramOng: body.instagramOng,
      linkedinOng: body.linkedinOng,
    };
    const { data } = await api.post(endpoint.updateOngUser, payload);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// assignOngToUser removed — admin creates ONGs now via /admin/ongs

/**
 * Get ONGs this professional belongs to.
 */
const getMyOngs = async () => {
  try {
    const { data } = await api.get(endpoint.myOngs);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Check if a personalID (cedula/passport) is already taken
const checkPersonalID = async (personalID, email) => {
  try {
    const { data } = await api.get(endpoint.checkPersonalID, {
      params: { personalID, email },
    });
    return data;
  } catch (error) {
    return { available: true, message: "" };
  }
};

export {
  firstLogin,
  updatePhoto,
  getUserData,
  updateDatosAdicionales,
  updateDatosPersonales,
  checkPersonalID,
  updateUser,
  getPatients,
  postPatientReport,
  updateCompleteProgress,
  getProfessionals,
  getProfessionalSpecialities,
  updateOngUser,
  getMyOngs,
};
